import { useEffect } from 'react';
import Image from 'next/image';
import gsap from 'gsap';

const AnimCard2 = () => {
  useEffect(() => {
    gsap.context(() => {
      gsap
        .timeline({
          repeat: -1
        })
        .fromTo(
          '.anim-card-2-js',
          {
            scale: 0
          },
          {
            scale: 1,
            stagger: 0.4,
            ease: 'back.out',
            duration: 0.5
          }
        )
        .to('.anim-card-2-js', {
          y: 1,
          duration: 1
        });
    });
  }, []);

  return (
    <>
      <div className="absolute inset-0">
        <Image
          src="/images/animcards/2/map.svg"
          width={228}
          height={193}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute top-[4%] left-[47%] origin-center | anim-card-2-js">
        <div className="aspect-[37/39]">
          <Image
            src="/images/animcards/2/h.svg"
            width={37}
            height={39}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <div className="absolute top-[26%] left-[18%] origin-center | anim-card-2-js">
        <div className="aspect-[26/26]">
          <Image
            src="/images/animcards/2/cart.svg"
            width={26}
            height={26}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <div className="absolute bottom-[20%] right-[11%] origin-center | anim-card-2-js">
        <div className="aspect-[37/39]">
          <Image
            src="/images/animcards/2/h.svg"
            width={37}
            height={39}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <div className="absolute top-[29%] right-[24%] origin-center | anim-card-2-js">
        <div className="aspect-[26/26]">
          <Image
            src="/images/animcards/2/cart.svg"
            width={26}
            height={26}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <div className="absolute top-[47%] left-[6%] origin-center | anim-card-2-js">
        <div className="aspect-[26/26]">
          <Image
            src="/images/animcards/2/cart.svg"
            width={26}
            height={26}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <div className="absolute top-[45%] left-[37%] origin-center | anim-card-2-js">
        <div className="aspect-[37/39]">
          <Image
            src="/images/animcards/2/h.svg"
            width={37}
            height={39}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <div className="absolute bottom-[8%] left-[23%] origin-center | anim-card-2-js">
        <div className="aspect-[26/26]">
          <Image
            src="/images/animcards/2/cart.svg"
            width={26}
            height={26}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </>
  );
};
export default AnimCard2;
